import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
//import { MoonLoader as Loader } from "react-spinners";
import styled, {withTheme, css} from 'styled-components';
import Popup from '../containers/popup';
import Icon from '../icon';
import { defaultTheme } from '../../data/themes';

//import Button from './button';


import { triggerActionEvent } from './common';
import { getPhrase } from '../../data/phrases';
import Form from './form';
import Button from './button';
import { isEmpty } from '../../data/validation';

const noop = () => {};

const PopupInputWrapper = styled.div`
position: relative;
background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};
border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
outline: ${props => props.theme.inputOutline ?? defaultTheme.inputOutline};
padding: ${props => props.theme.inputPadding ?? defaultTheme.inputPadding};

&::selection {
	background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
	color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
}

&.readonly {
	background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
	color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
}

&.combo:not(.readonly) {
	.text {
		cursor: pointer;
	}
}

> .layout {
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};

	.text {
		flex-grow: 1;
		white-space:nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		border: none;
		outline: none;
		width: 100%;
		font-weight: ${props => props.theme.inputFontWeight ?? defaultTheme.inputFontWeight};
		font-size: ${props => props.theme.inputFontSize ?? defaultTheme.inputFontSize};
		padding: 0px 2px;
		color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
		background: transparent;
		text-align: ${props => props.textAlign};

		&::selection {
			background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
			color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
		}

		&[readonly] {
			color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
		}

		::placeholder {
			color: ${props => props.theme.inputPlaceholderColor ?? defaultTheme.inputPlaceholderColor};
			font-weight: ${props => props.theme.inputPlaceHolderFontWeight ?? defaultTheme.inputPlaceHolderFontWeight};
		}

	}
	> .icon {
		position: relative;
		top: -1px;
		color: ${props => props.theme.lookupInputIconColor ?? props.theme.inputColor ?? defaultTheme.inputColor} !important;
		flex-grow: 0;
		font-size: 12px;
		padding-left: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
		padding-right: ${props => props.theme.lookupInputIconHorizontalPadding ?? defaultTheme.lookupInputIconHorizontalPadding};
		&[data-name=clear] {
			margin-right: ${props => props.theme.lookupInputClearIconMarginRight};
		}
	}
}
`;

const EMPTY_MAP = Immutable.Map({});

export default class PopupInput extends React.PureComponent {
	constructor() {
		super();

		this.state = {
			text: '',
			popupOpen: false,
			popupValue: null,
		};

		this.containerRef = React.createRef();
		this.popupRef = React.createRef();
		this.inputRef = React.createRef();
		this.getPopupAnchor = this.getPopupAnchor.bind(this);
		this.onInputMouseDown = this.onInputMouseDown.bind(this);
		this.openPopup = this.openPopup.bind(this);
		this.closePopup = this.closePopup.bind(this);
		this.onHideRequested = this.onHideRequested.bind(this);
		this.onPopupControlChange = this.onPopupControlChange.bind(this);
		this.onOk = this.onOk.bind(this);
	}

	clear() {
		this.onChange(null);
	}

	onOk() {
		this.onChange(this.state.popupValue);
		this.closePopup();
	}

	onPopupControlChange(value) {
		this.setState({
			popupValue: value
		});
	}

	onChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	getPopupAnchor() {
		let el = this.containerRef.current;
		/*let formItem = el.closest('.ps-popupAnchor');
		if (formItem) {
			el = formItem;
		}*/
		return el.getBoundingClientRect();
	}

	closePopup() {
		this.setState({
			popupOpen: false
		});
	}

	onHideRequested() {
		this.closePopup();
	}

	openPopup(filter) {
		this.setState({
			popupOpen: true
		});
	}

	onInputMouseDown(e) {
		if (!this.props.readOnly) {
			if (this.state.popupOpen) {
				return;
			}
			window.setTimeout(() => {
				this.openPopup('');
			}, 0);
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.value != prevState.propValue) {
			return {
				popupValue: nextProps.value,
				propValue: nextProps.value
			}
		} else {
			return null;
		}

	}

	render() {
		const hasValue = !isEmpty(this.props.value);
		const PopupControl = this.props.popupControl;
		return (
			<PopupInputWrapper
				width={this.props.width}
				data-name={this.props.name}
				data-value={this.props.value}
				textAlign={this.props.textAlign}
				className={
					'component ps-input popupInput ' +
					(hasValue ? 'set' : 'empty') +
					(this.props.readOnly ? ' readonly' : '') +
					(true ? ' combo' : '') +
					(' ' + (this.props.className || '')) +
					(' ' + (this.state.error || ''))
				}
				ref={this.containerRef}
			>
				<div className="layout">
				{
					hasValue && !this.props.readOnly && !this.props.mandatory && (
						<Icon
							name="clear"
							active
							onMouseDown={e => {
								e.preventDefault();
								this.clear();
							}}
						/>

					)
				}
				{/*<input
					type="text"
					className={'text lookup' + (this.props.readOnly ? ' readOnly' : '')}
					data-autofocusid={this.props.autoFocusId}
					ref={this.inputRef}
					value={this.props.text || ''}
					onChange={noop}
					onKeyDown={this.onKeyDown}
					spellCheck="false"
					title={this.props.hint}
					readOnly={this.props.readOnly}
					tabIndex={this.props.readOnly ? '-1' : '0'}
					placeholder={this.state.text || this.props.placeholder}

					onMouseDown={this.onInputMouseDown}
			/>*/}
				<div
					className="text"
					onMouseDown={this.onInputMouseDown}
				>{this.props.text || '\u00A0'}</div>
				{
					this.props.readOnly || this.props.noDropDown ? null : (
						<Icon
							name="dropDown"
							active
							onMouseDown={e => {
								e.preventDefault();
								if (this.state.popupOpen) {
									return;
								}
								window.setTimeout(() => {
									this.openPopup('');
								}, 0);
							}}
						/>
					)
				}
				</div>
				{
					this.state.popupOpen && (!this.props.hideEmptyPopup || (this.state.rows.size > 0)) && (
						<Popup
							getAnchor={this.getPopupAnchor}
							onHideRequested={this.onHideRequested}
							ref={this.popupRef}
							//className="lookup"
							minWidth={this.props.minPopupWidth}
							maxHeight={this.props.maxPopupHeight}
							lookup
						>
							<PopupWrapper>
								<Form virtual onAction={this.onOk} width="200px">
									<PopupControl
										{...this.props.popupControlProps}
										value={this.state.popupValue}
										onChange={this.onPopupControlChange}
									/>
								</Form>
								<BottomToolbar>
									<Button
										text={getPhrase('ok')}
										onAction={this.onOk}
									/>
								</BottomToolbar>
							</PopupWrapper>
						</Popup>
					)
				}
			</PopupInputWrapper>
		);
	}

}

const PopupWrapper = styled.div`
	padding: ${props => props.theme.popupInputPopupPadding || '4px'};
`;

const BottomToolbar = styled.div`
	text-align: right;
	margin: ${props => props.theme.popupInputButtonToolbarMargin};
`;

